import React, { useState, useEffect } from 'react';
import { get } from '../../util/request';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { userInfo } from '../../redux/slice';
import Loading from '../../components/common/loading.js';
import { useTranslation } from 'react-i18next';
import ExitBanner from '../../components/page/exitBanner/index.js';
import { Pagination } from 'antd';
import './index.scss'

export default Products; function Products() {

  const history = useHistory();
  const fromAccreditation = !!history.location.state?.fromAccreditation;
  const { t } = useTranslation();
  const user = useSelector(userInfo);
  const [productDetails, setProductDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchName, setSearchName] = useState('');

  useEffect(() => {
    if (fromAccreditation) return;
    const pd = JSON.parse(sessionStorage.getItem('previewDetail'));
    const isClientView = (pd !== null && pd?.sfUserType === 'CL') ||
      (pd === null && user?.sfUserType === 'CL');
    if (!isClientView) return;
    const country = pd !== null ? pd?.country : user?.country;
    if (country === 'Singapore') return;
    const hasActiveInv = pd !== null ? pd?.hasActiveInvestment : user?.hasActiveInvestment;
    const hasProds = pd !== null ? pd?.hasProducts : user?.hasProducts;
    if (hasActiveInv === false || !hasProds) {
      history.push(history.location.pathname.startsWith('/preview/') ? '/preview/document' : '/document');
    }
  }, []);

  const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));

  const goto = (id) => {
    history.push({
      pathname: `products/${id}`,
      state: fromAccreditation ? { fromAccreditation: true } : undefined
    });
  }

  const backToAccreditation = () => {
    history.push({
      pathname: user.sfUserType === 'IR' ? '/preview/clientAccreditation' : '/clientAccreditation'
    });
  }



  useEffect(() => {
    if (!user.sfUserType) return;

    if (user.sfUserType === 'CL' && history.location.pathname.toLowerCase().includes('preview')) {
      history.push({ pathname: '/products' });
      return;
    } else if (user.sfUserType === 'IR' && history.location.pathname.toLowerCase() === '/products') {
      history.push({ pathname: '/preview/products' });
      return;
    }

    const isSG = user.sfUserType === 'IR'
      ? previewDetail?.country === 'Singapore'
      : user.country === 'Singapore';

    if (isSG && !fromAccreditation) {
      const hasAccess = user.sfUserType === 'IR'
        ? previewDetail?.aiDecision === 'Yes' || previewDetail?.isClientAccredited === true
        : user.aiDecision === 'Yes' || user.isClientAccredited === true;
      if (!hasAccess) {
        history.push({ pathname: user.sfUserType === 'IR' ? '/preview/home' : '/home' });
        return;
      }
    }

    projects('');
  }, [user.sfUserType, user.region, previewDetail?.regionCode]);

  useEffect(() => {
    projects(searchName);
  }, [pageNum, pageSize, window.localStorage.lang]);


  const handleSearchChange = async (value) => {
    setSearchName(value);
  }

  const handleKeyDown = async (e) => {
    if (e.keyCode === 13) {
      projects(searchName);
    }
  }

  const handleClear = async () => {
    setSearchName('');
    projects('');
  }


  const projects = async (search) => {
    setLoading(true);
    let params = {
      size: pageSize,
      page: pageNum > 0 ? pageNum - 1 : 0,
      userId: user.userId,
      accessToken: user.accessToken,
      projectName: search,
      language: window.localStorage.lang.toUpperCase()
    };

    const data = await get('/projects', params);
    if (data) {
      setProductDetails(data.content);
      setTotal(data.totalElements);
    }
    setLoading(false);
  }


  return (
    ((user.sfUserType === 'CL' && (user.country === 'Singapore' ? (fromAccreditation || user.aiDecision === 'Yes' || user.isClientAccredited === true) : (user.hasActiveInvestment && user.hasProducts))) ||
     (user.sfUserType === 'IR' && (previewDetail?.country === 'Singapore' ? (fromAccreditation || previewDetail?.aiDecision === 'Yes' || previewDetail?.isClientAccredited === true) : (previewDetail?.hasActiveInvestment && previewDetail?.hasProducts)))) && <>
      {loading ? <Loading /> : null}
      <div className='product'>
        <div className='main-box'>
          <div className='row'>
            <ExitBanner isMissingProfileBannerOpen={true} isUpdateProfileButtonVisible={true} />
          </div>
          <div className="headline product-wrapper">
            <div className='col-md-4 product-title'><p>{t('Products')}</p></div>
            <div className='col-md-8 product-header'></div>
          </div>
          <div className='submit-box product-container'>
            {fromAccreditation && (
              <div className='product-back' onClick={() => backToAccreditation()}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
                <span>{t('Client Accreditation')}</span>
              </div>
            )}
            <div className='product-search'>
              <input type='text' className='form-control' value={searchName} placeholder={t("Project Name")} onKeyDown={handleKeyDown} onChange={(e) => handleSearchChange(e.target.value)} />
              <button className='btn btn-outline-theme' onClick={() => projects(searchName)}>{t('Search')}</button>
              <span onClick={() => handleClear()}>{t('Clear')}</span>
            </div>
            {
              productDetails.length > 0 && (<>
                {
                  productDetails.map((product) => (<>
                    <div className='product-tiles row col-md-12'>
                      <div className='col-md-4 thumbnail' onClick={() => goto(product.id)}>
                        {
                          product.status !== 'AVAILABLE' ? (<>
                            <span className='thumbnail-status'>
                              {t(product.status)}
                            </span>
                            <img src={product.thumbnail} alt='' style={{ position: "relative", top: "-34px" }} />
                          </>) : product.isNew === true ? (<>
                            <span className='thumbnail-status'>
                              {t('New')}
                            </span>
                            <img src={product.thumbnail} alt='' style={{ position: "relative", top: "-34px" }} /></>) : (<><img src={product.thumbnail} alt='' /></>)
                        }
                      </div>
                      <div className='col-md-8 product-description'>
                        <div className='product-title'>
                          {product.name}
                        </div>
                        <div className='product-content' style={{overflowWrap: 'break-word' }}>
                          {product.brief}
                        </div>
                        <div className='product-goto' onClick={() => goto(product.id)}>
                          {product.address}
                        </div>
                      </div>
                    </div>
                  </>))
                }
                <div className='product-pagination'>
                  <Pagination
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    pageSize={pageSize}
                    pageSizeOptions={[10, 20, 50, 100]}
                    onChange={(page, pageSize) => {
                      setPageNum(page);
                    }}
                    onShowSizeChange={(current, size) => {
                      setPageSize(size);
                    }}
                    showTotal={(total) => `${t('Total')} ${total} ${t('items')}`}
                  />
                </div>
              </>)
            }
          </div>
        </div>
      </div>
    </>)
}
